import { $$ } from "../../sharedscripts/OO_jquery";
export function scrollModify(lock, submodifer) {
  var scrolls = [
    ".modifier-container",
    ".item-description-container",
    ".item-summary",
    ".modifier-group-container",
    ".combo-modifier-list",
    ".combo-modifier-details",
    ".terms-and-conditions",
    ".extra-items-wrapper",

  ];
  if (submodifer) {
    scrolls = [".item-details"]
  }
  const bodyScrollLock = require("body-scroll-lock");
  bodyScrollLock.clearAllBodyScrollLocks();
  const options = {
    reserveScrollBarGap: true,
  };
  if (isIos()) {
    scrolls.forEach(elm => {
      var targetElement = $$(elm);
      for (var i = 0; i < targetElement.length; i++) {
        if (lock) {
          bodyScrollLock.disableBodyScroll(targetElement[i], options);

        } else {
          bodyScrollLock.enableBodyScroll(targetElement[i]);

        }
      }
      if (!lock) { bodyScrollLock.clearAllBodyScrollLocks(); }
    });
  }
}
export function isIos() {
  return !!navigator.platform.match(/iPhone|iPod|iPad/) || !!navigator.platform.match(/Mac68K|MacPPC|MacIntel/);
}
